import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IStoreStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IStoreStatsResponse>,
  IPathBaseParam,
  object
>("stores.storeStats");

export const storeStats = {
  ...getApis,
};
